import React from 'react';
import { Props } from '../../GalleryView';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import { TorpedoLayoutConfig } from '../../../../Torpedo/types';
import Torpedo from '../../../../Torpedo';
import EditorDeviationLink from '../../../MonoView/_partials/DeviationLink';
import Thumb from '../../../ThumbView';

const GalleryTorpedo: React.FC<Props> = ({
  deviations,
  layoutRowAlignment,
  torpedoRowHeight,
  width,
  layoutSpacing,
  extOptions,
  itemCropping,
  linkOverrides,
}) => {
  const container = {
    width,
  };

  const items: any = [];
  for (const dev of deviations) {
    const largest = DeviationMediaService.getThumbDimensions(dev);
    items.push({
      id: dev.deviationId,
      width: largest.width,
      height: largest.height,
      deviation: dev,
    });
  }
  let layoutConfig: TorpedoLayoutConfig = {
    galleryGutter: true,
    itemSpacingDesktop: 4,
    itemSpacingMobile: 4,
  };
  layoutConfig = {
    rowSizeDesktop: torpedoRowHeight ?? 200,
    rowSizeCardDesktop: torpedoRowHeight ?? 200,
    rowSizeMobile: torpedoRowHeight ?? 200,
    rowSizeCardMobile: torpedoRowHeight ?? 200,
    rowSizeMobileLarge: torpedoRowHeight ?? 200,
  };
  if (layoutSpacing !== undefined) {
    layoutConfig = {
      ...layoutConfig,
      itemSpacingDesktop: layoutSpacing ?? 8,
      itemSpacingMobile: layoutSpacing ?? 8,
    };
  }

  let rowAlign;
  let gridStyles: React.CSSProperties = {};
  if (layoutRowAlignment) {
    const settingToCss = {
      left: 'flex-start',
      right: 'flex-end',
      center: 'center',
    };
    gridStyles = {
      display: 'flex',
      justifyContent: settingToCss[layoutRowAlignment],
    };
    rowAlign = layoutRowAlignment;
  }

  // Key is to help with live preview as torpedo is heavily update protected
  return (
    <div className="daeditor-torpedo-grid" style={gridStyles}>
      <Torpedo
        rowAlign={rowAlign}
        key={`torpedo-${itemCropping}`}
        layoutConfig={layoutConfig}
        items={items}
        container={container}
        enableScrollVisibilityOptimisation={false}
        renderItem={(props, item, itemStyle) => {
          const deviation = item.dto.deviation;
          const { width: itemWidth, height: itemHeight } = item;
          return (
            <div
              className="daeditor-torpedo-grid-item"
              key={`torpedo-${deviation.deviationId}`}
              style={{ width: itemWidth, height: itemHeight, ...itemStyle }}
              data-deviation={JSON.stringify(deviation)}
            >
              <EditorDeviationLink
                link={extOptions?.canLink ? linkOverrides?.[deviation.deviationId] : undefined}
                deviation={deviation}
                data-deviationId={extOptions?.canLink ? deviation.deviationId : undefined}
              >
                <Thumb
                  deviation={deviation}
                  width={itemWidth}
                  height={itemHeight}
                  allowPreviewUsage
                  noCropping={itemCropping === 'crop' ? true : false}
                />
              </EditorDeviationLink>
            </div>
          );
        }}
      />
    </div>
  );
};
GalleryTorpedo.displayName = 'GalleryTorpedo';

export default GalleryTorpedo;
